import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography } from '@biome-design-system/ui/Typography';
import { Link } from '@biome-design-system/ui/Link';
import { SearchTermText } from '../SearchTermText';
import { SearchLink } from 'Src/types/search';
import { type Log, type GetUpdatedSearch } from 'Src/types';

interface InterpretationSearchTermProps {
  renderAsLink: boolean;
  term: SearchLink;
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}

export const InterpretationSearchTerm = ({
  renderAsLink,
  term,
  getUpdatedSearch,
  log
}: InterpretationSearchTermProps) => {
  if (!renderAsLink) {
    return <SearchTermText displayText={term.display_text} />;
  }
  const handleClick = (): void => {
    log('user_action.search_results.search_term_link_clicked', {
      term: term.display_text,
      category: term.display_search_type
    });
  };
  return (
    <Typography component="span" sx={{ whiteSpace: 'nowrap' }}>
      &quot;
      <Link
        component={RouterLink}
        onClick={handleClick}
        to={getUpdatedSearch(term.query_modifications)}
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold
        })}
      >
        {term.display_text}
      </Link>
      &quot;
    </Typography>
  );
};
